import { render } from "./Signup.vue?vue&type=template&id=679d9b14&scoped=true"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=679d9b14&scoped=true&lang=css"

import exportComponent from "/home/luvenan/projects/get-it-done/get-it-done/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679d9b14"]])

export default __exports__